import { Card } from '@sparemin/blockhead';
import React from 'react';
import { useSelector } from 'react-redux';
import { Replace } from 'components/icons';
import UpsellBanner from 'components/UpsellBanner';
import useContextualUpgrade from 'hooks/useContextualUpgrade';
import { loggedInSelector } from 'redux/modules/auth';
import { hasRestoreEmbedVideoAccessSelector } from 'redux/modules/pricing';
import { block } from '../../utils';
import ArchivedVideoSectionContents from './ArchivedVideoSectionContents';
import ArchivedVideoSectionRestoreButton from './ArchivedVideoSectionRestoreButton';

export interface DownloadPageArchivedVideoSectionProps {
  embedVideoId: number;
  onRestoreSuccess?: () => void;
}

const DownloadPageArchivedVideoSection: React.FC<DownloadPageArchivedVideoSectionProps> = ({
  embedVideoId,
  onRestoreSuccess,
}) => {
  const isLoggedIn = useSelector(loggedInSelector);
  const hasRestoreEmbedVideoAccess = useSelector(
    hasRestoreEmbedVideoAccessSelector,
  );

  const { onUpgrade } = useContextualUpgrade();

  return (
    <Card className={block('archived-video-section')}>
      {!hasRestoreEmbedVideoAccess && isLoggedIn && (
        <UpsellBanner
          heading="Restore archived videos"
          icon={<Replace className={block('upgrade-to-restore-icon')} />}
          actionLabel="upgrade now"
          className={block('upgrade-to-restore-contents')}
          onUpgradeClick={onUpgrade}
        />
      )}

      <ArchivedVideoSectionContents />

      {hasRestoreEmbedVideoAccess && isLoggedIn && (
        <ArchivedVideoSectionRestoreButton
          {...{ embedVideoId, onRestoreSuccess }}
        />
      )}
    </Card>
  );
};

export default DownloadPageArchivedVideoSection;
